// extracted by mini-css-extract-plugin
export default {"heading":"DeleteGuildModal_heading__Hv3Tn"};